import { StorageService, STORAGE_KEY } from '../services/storage/storage.service';
import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Endpoints } from '@api/constants/endpoints.constants';
import { environment } from '@environment/environment';
@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private router: Router, private storageService: StorageService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // add authorization header with jwt token if available
    const idToken = this.storageService.getItem(STORAGE_KEY.TOKEN);
    const exception = request.url.includes(Endpoints.products) && !!request.params.get('email');
    const headers: Record<string, string> = {};
    const needToken = idToken && !exception;
    const needContentType = !request.url.includes(environment.endpoints.documentation.uploadDocuments);

    if (needToken) {
      headers.Authorization = `Bearer ${idToken}`
    }

    if (needContentType) {
      headers['Content-Type'] = 'application/json'
    }

    if (idToken && !exception) {
      request = request.clone({
        setHeaders: headers,
      });
    }

    return next.handle(request).pipe(
      catchError((error, caught) => {
        // intercept the respons error and displace it to the console
        return this.handleAuthError(error);
      }) as any
    );
  }

  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    // handle your auth error or rethrow

    if (err.status === 401 || err.status === 403) {
      // Delete localStorage and redirect to login
      this.storageService.revmoveAll();
      this.router.navigate(['/login']);
      // if you've caught / handled the error, you don't want to rethrow it unless
      // you also want downstream consumers to have to handle it as well.
    }

    return throwError(err.error);
  }
}
